import ApiService from "@/services/api.service";

const route = 'type_profiles';

const type_profiles = {
    all(){
        return new Promise((resolve, reject) => {
            ApiService.get(route).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    get(_id) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _id).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default type_profiles;